"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneLink = void 0;
const params_1 = require("./params");
const on_boarding_1 = require("./on-boarding");
class OneLink extends URL {
    constructor(factoryConfig, oneLinkConfig, init) {
        super(init || OneLink._BASE_URL);
        this._factoryConfig = factoryConfig || {};
        this._oneLinkConfig = oneLinkConfig || {};
        this.params = new params_1.OneLinkParamsDelegate(this);
        this.onBoarding = new on_boarding_1.OneLinkOnboardingDelegate(this);
        this._init();
        (this._factoryConfig.hooks || []).forEach((hook) => hook.afterCreate?.(this));
    }
    _init() {
        if (this._oneLinkConfig.schema) {
            this.params.deepLink = this._oneLinkConfig.schema;
        }
    }
    active() {
        const url = new OneLink({}, {}, this);
        this._factoryConfig.hooks?.forEach((hook) => hook.onActive?.(url));
        const target = url.toString();
        window.open(target);
    }
    toMetaAppLink() {
        const schema = this.params.deepLink;
        if (!schema) {
            throw new Error('af_dp is not configured');
        }
        const schemaURL = new URL(schema);
        /**
         * copy all OneLink params to Schema
         */
        this.searchParams.forEach(([value, key]) => {
            schemaURL.searchParams.set(key, value);
        });
        return schemaURL.toString();
    }
}
exports.OneLink = OneLink;
OneLink._BASE_URL = 'https://lemon8.onelink.me/FMQw';
